module.exports = __webpack_public_path__ + "../resources/img/bg_pv2_02.5c07b6e3.png";